<template>
  <div class="approval-review">
    <div class="approval-review__images">
      <approval-review-image-preview
        v-if="proofs && proofs.some(proof => proof !== null)"
        :proofs="proofs"
      />
      <approval-review-loader v-else />
    </div>
    <div class="approval-review__info-wrapper">
      <div class="approval-review__info-wrapper--vertical-line"></div>
      <approval-review-info>
        <template #checkout>
          <checkbox-group
            :mode="E_CHECKBOX_GROUP_MODE.SINGLE"
            :checkbox-list="checkboxList"
            @checkout-checkbox="changeCheckoutCheckboxHandler"
          />
          <finish-button @finish="checkoutFinishHandler" />
        </template>
      </approval-review-info>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { useEditorStore, useConfigStore } from '../../stores';
import pinia from '../../core/pinia';

import FinishButton from '../ui/FinishButton.vue';
import CheckboxGroup from '../ui/CheckboxGroup.vue';
import ApprovalReviewLoader from './ApprovalReviewLoader.vue';
import ApprovalReviewImagePreview from './ApprovalReviewImagePreview.vue';
import ApprovalReviewInfo from './ApprovalReviewInfo.vue';

import { E_CHECKBOX_GROUP_MODE } from '../../types/components.enums';
import { E_APPROVAL_REVIEW_EVENT } from '../../types/components-events.enums';
import type { ILineItem } from '../../types/line-item.types';
import type { TApprovalReviewEventResponse } from '../../types/event-response.types';
import type { TCheckboxGroupSelectedItems } from '../../types/checkbox-group.types';

const emit = defineEmits<{
  (event: E_APPROVAL_REVIEW_EVENT.CHANGE_CHECKOUT_CHECKBOX, eventResponse: TApprovalReviewEventResponse[E_APPROVAL_REVIEW_EVENT.CHANGE_CHECKOUT_CHECKBOX]): void;
  (event: E_APPROVAL_REVIEW_EVENT.CHECKOUT_FINISH, eventResponse: TApprovalReviewEventResponse[E_APPROVAL_REVIEW_EVENT.CHECKOUT_FINISH]): void;
}>();

const editorStore = useEditorStore(pinia);
const configStore = useConfigStore(pinia);

const proofs = computed(() => editorStore.getProofs);
const checkboxList = computed(() => configStore.getApprovalCheckboxList || []);

function changeCheckoutCheckboxHandler(checkboxGroupSelectedItems: TCheckboxGroupSelectedItems) {
  emit(E_APPROVAL_REVIEW_EVENT.CHANGE_CHECKOUT_CHECKBOX, checkboxGroupSelectedItems);
}

function checkoutFinishHandler(lineItem: ILineItem | null) {
  emit(E_APPROVAL_REVIEW_EVENT.CHECKOUT_FINISH, lineItem);
}
</script>

<style scoped lang="scss">
.approval-review {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  color: #6A747C;

  &__images {
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 13px;
  }

  &__info-wrapper {
    display: grid;
    grid-template-columns: 20px 370px;

    &--vertical-line {
      border-left: 1px solid #D7D9DB;
      height: 100%;
    }
  }
}

@media screen and (max-width: 768px) {
  .approval-review {
    flex-wrap: wrap;
    justify-content: center;

    &__info-wrapper {
      display: flex;
      flex-direction: column;
    }

    &__images {
      padding: 8px 0;
    }
  }
}
</style>